export const ALL_CONFIGS_KEY = '$allConfigs';
export const LAUNCHER_DATA_STORAGE_KEY = 'cgp_client';